export default {
  apiKey: "AIzaSyCYi4By4_Q_h8SOAs2KtADnAJgxwey_bOc",
  authDomain: "mgdconfigurator.firebaseapp.com",
  projectId: "mgdconfigurator",
  storageBucket: "mgdconfigurator.firebasestorage.app",
  messagingSenderId: "793131735662",
  appId: "1:793131735662:web:6d3ed3be099d3867b7247f"
};